import type { CSSProperties, ReactNode } from "react";
import { tokens, hairline } from "../tokens";
import { Label } from "./Label";

interface CardProps {
	children: ReactNode;
	// Micro cap heading rendered above the body, separated by a hairline.
	title?: ReactNode;
	// Right aligned control or value that sits on the title row.
	action?: ReactNode;
	padded?: boolean;
	style?: CSSProperties;
}

// The base surface: one colour at low alpha over the ground, edged by a single hairline. The edge
// carries the object, not a fill and not a shadow. Shape is generous so it reads as a raised object.
export function Card({ children, title, action, padded = true, style }: CardProps) {
	return (
		<section
			style={{
				background: tokens.color.surface.raised,
				border: hairline(tokens.color.stroke.hairline),
				borderRadius: tokens.radius.lg,
				overflow: "hidden",
				...style,
			}}
		>
			{title !== undefined && (
				<header
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						gap: tokens.space.md,
						padding: `${tokens.space.md}px ${tokens.space.lg}px`,
						borderBottom: hairline(tokens.color.stroke.divider),
					}}
				>
					<Label>{title}</Label>
					{action}
				</header>
			)}
			<div style={{ padding: padded ? tokens.space.lg : 0 }}>{children}</div>
		</section>
	);
}
